import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import React, {useEffect, useState} from "react";

const TextQuestion = observer(({question, index})=> {
    const {generalStore, rtcStore, modalStore, surveyStore} = useStores();

    return (
        <>
            <div className="py-2 text-xs">{generalStore.translate('yourFeedback')}:</div>
            <div className="flex flex-col justify-between items-center gap-2">
                <textarea
                    value={question.TextValue || ''}
                    onChange={(e) => (question.TextValue = e.target.value)}
                    maxLength={1000}
                    placeholder={generalStore.translate("TypeYourResponseHere")+"..."}
                    className="
                        w-full
                        min-h-11
                        px-3
                        py-2
                        rounded-xl
                        outline outline-1 outline-panels-normal outline-offset-[-1px]
                        bg-inputfield-normal
                        text-main-normal
                        text-sm
                        font-sans
                        font-normal
                        leading-[17.14px]
                        resize-none
                        placeholder-main-disabled
                      "
                />
            </div>
        </>
    );
});

export default TextQuestion;
